import { render, staticRenderFns } from "./NiceToMeets.vue?vue&type=template&id=b0f1f47c&scoped=true"
import script from "./NiceToMeets.vue?vue&type=script&lang=js"
export * from "./NiceToMeets.vue?vue&type=script&lang=js"
import style0 from "./NiceToMeets.vue?vue&type=style&index=0&id=b0f1f47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f1f47c",
  null
  
)

export default component.exports